import MainLayout from "./MainLayout";
import Security1 from "../assets/images/Security1.png";
import Security2 from "../assets/images/security2.png";
import Security3 from "../assets/images/Security3.jpg";



const Security = () => {
  return (
    <MainLayout>
      {/* Top Banner */}
      <section className="w-full bg-black text-white py-20">
        <h1 className="text-center text-5xl md:text-7xl font-extrabold text-gray-200 leading-tight pt-2">
          Our Commitment to Security
        </h1>
      </section>

      {/* Content Section */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 text-center space-y-14">
        {/* Heading */}
        <div className="space-y-6 max-w-3xl mx-auto">
          <h2
            className="text-4xl md:text-5xl font-bold
      bg-gradient-to-r from-blue-500 to-pink-500
      bg-clip-text text-transparent"
          >
            Compliance & Certifications
          </h2>

          <p className="text-lg text-gray-200 leading-relaxed">
            XynexAI is committed to meeting industry-leading security and
            compliance standards. Our controls, processes, and infrastructure
            are designed to protect customer data and ensure trust at every
            level.
          </p>
        </div>

        {/* Certifications */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 max-w-5xl mx-auto">
          {/* TX-RAMP */}
          <div className="flex flex-col items-center space-y-4">
            <img
              src={Security1}
              alt="TX-RAMP Compliance"
              className="w-38 h-28 object-contain"
            />
          </div>

          {/* SOC 2 */}
          <div className="flex flex-col items-center space-y-4">
            <img
              src={Security2}
              alt="SOC 2 Type II"
              className="w-32 h-28 object-contain"
            />
          </div>

          {/* GDPR */}
          <div className="flex flex-col items-center space-y-4">
            <img
              src={Security3}
              alt="GDPR Compliant"
              className="w-28 h-28 object-contain"
            />
          </div>
        </div>

        {/* Security Description */}
        <div className="max-w-4xl mx-auto text-left space-y-6 text-gray-200 pt-10">
          <p>
            At XynexAI, we understand that data security is paramount. We are
            committed to implementing robust security measures to protect
            sensitive information from unauthorized access, disclosure,
            alteration, and destruction.
          </p>

          <p>
            Our security framework follows a multi-layered approach, including
            encryption of data at rest and in transit, strict access controls,
            continuous monitoring, and regular security audits aligned with
            industry best practices.
          </p>

          <p>
            For more detailed information about our security controls and
            policies, please refer to our Terms of use and Privacy Policy.
          </p>
        </div>
      </section>
    </MainLayout>
  );
};

export default Security;